import React from "react";
import * as S from "./Accordion.styles";

export interface AccordionSectionHeaderProps {
  /**
   * Content of the section header
   */
  children: React.ReactNode;

  /**
   * Optional callback for the Clear button
   */
  onClear?: (() => void) | null;

  /**
   * Whether the section is disabled
   */
  disabled?: boolean;

  /**
   * When true, the divider will not be rendered
   */
  shouldDisableDivider?: boolean;

  /**
   * Optional content to render next to the trigger
   */
  triggerSibling?: React.ReactNode;
}

export const AccordionSectionHeader = ({
  children,
  onClear,
  disabled,
  shouldDisableDivider,
  triggerSibling
}: AccordionSectionHeaderProps) => {
  return (
    <S.Header>
      <S.Title>{children}</S.Title>
      {!shouldDisableDivider && <S.Divider />}
      {onClear && (
        <S.ClearButton onClick={() => onClear()}>Clear</S.ClearButton>
      )}
      <S.TriggerContainer>
        {triggerSibling && triggerSibling}
        <S.Trigger aria-label="trigger">
          {!disabled && <S.Chevron aria-label="chevron" />}
        </S.Trigger>
      </S.TriggerContainer>
    </S.Header>
  );
};
